import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

const BrandView = () => {
  const { id } = useParams();
  const [record, setRecord] = useState(null);
  const [cdnConfig, setCdnConfig] = useState(null);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  // ✅ CDN Config yükle
  useEffect(() => {
    const fetchCdnConfig = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/cdn-config`);
        setCdnConfig(res.data);
      } catch (err) {
        console.error(getText("CDN_CONFIG_FETCH_ERROR"), err);
      }
    };
    fetchCdnConfig();
  }, []);

  // ✅ Marka bilgisi getir
  useEffect(() => {
    const fetchBrand = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/stock-brands/${id}`);
        setRecord(res.data);
      } catch (err) {
        console.error(getText("BRAND_FETCH_ERROR"), err);
      }
    };
    fetchBrand();
  }, [id]);

  if (!record) return <p>{getText("LOADING")}</p>;

  // ✅ buildCdnUrl — SalesPage ile aynı fonksiyon
  const buildCdnUrl = (filename) => {
    if (!filename || !cdnConfig) return "/no-image.jpg";

    const base = cdnConfig.cdn_path?.replace(/\/$/, "") || "";
    const folder = cdnConfig.cdn_folder?.replace(/\/$/, "") || "";

    return folder ? `${base}/${folder}/${filename}` : `${base}/${filename}`;
  };

  // ✅ Görsel kaynağı: varsa CDN, yoksa local
  const imageSrc = record.image_cdn
    ? buildCdnUrl(record.image_cdn)
    : record.image
      ? `${API_BASE}${record.image}`
      : "/no-image.jpg";

  return (
    <div className="container mt-4">
      <div className="card shadow-sm p-4">
        {/* Başlık + Geri */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold">{record.title}</h4>
          <Link to="/brands/table" className="btn btn-sm btn-secondary">
            {getText("BACK")}
          </Link>
        </div>

        {/* Logo */}
        <div className="mb-3 text-center">
          <img
            src={imageSrc}
            alt={record.title}
            className="img-fluid rounded border"
            style={{
              maxHeight: 200,
              objectFit: "contain",
              background: "#fff",
            }}
            onError={(e) => (e.target.src = "/no-image.jpg")}
          />
        </div>

        {/* Bilgi Tablosu */}
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th style={{ width: 200 }}>{getText("STATUS_LABEL")}</th>
              <td>
                <span
                  className={`badge ${
                    record.status === "aktif" ? "bg-success" : "bg-danger"
                  }`}
                >
                  {record.status === "aktif"
                    ? getText("STATUS_ACTIVE")
                    : getText("STATUS_PASSIVE")}
                </span>
              </td>
            </tr>
            <tr>
              <th>{getText("CREATED_AT_LABEL")}</th>
              <td>
                {new Date(record.created_at).toLocaleString(
                  language === "en" ? "en-US" : "tr-TR",
                )}
              </td>
            </tr>
            <tr>
              <th>{getText("UPDATED_AT_LABEL")}</th>
              <td>
                {new Date(record.updated_at).toLocaleString(
                  language === "en" ? "en-US" : "tr-TR",
                )}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Düzenle Butonu */}
        <div className="mt-4 text-end">
          <Link to={`/brands/edit/${id}`} className="btn btn-primary">
           {getText("EDIT")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BrandView;
